module.exports = __webpack_public_path__ + "assets/img/f1a57ca0132f792237c45c74f4719b4e.png";